import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'

import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

import ContactInput from 'components/ContactInput'
import ErrorDialog from 'components/ErrorDialog'
import Panel from 'components/Panel'
import { updateDoc, useDoc } from 'lib/firestore'

export default function ContactSetting({ account }) {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const { item } = useDoc(`accounts/${account.id}`)

  useEffect(() => {
    if (item?.contact) {
      Object.entries(item.contact).forEach(([key, value]) => setValue(key, value))
    }
  }, [item, setValue])

  const onSubmit = async values => {
    setLoading(true)
    updateDoc(`accounts/${account.id}`, { contact: values })
      .then(() => setLoading(false))
      .catch(error => {
        setError(error)
        setLoading(false)
      })
  }

  return (
    <Panel sx={{ p: 3 }}>
      <Typography
        sx={{
          pb: 1,
          mb: 3,
          borderBottom: theme => `1px solid ${theme.palette.divider}`,
        }}
        variant="h3"
      >
        代表連絡先
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ContactInput control={control} disabled={loading} errors={errors} required />
        <div style={{ textAlign: 'right' }}>
          <Button color="primary" type="submit" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : '保存'}
          </Button>
        </div>
        {Boolean(error) && (
          <ErrorDialog
            error="エラーが発生しました。大変お手数ですがしばらくしてから再度お試しください"
            onClose={() => setError(null)}
          />
        )}
      </form>
    </Panel>
  )
}
